/* EAR PLAN — masthead condenses once the page is scrolled (CSS does the rest through .is-stuck).
   The theme scrolls inside .page-wrapper rather than the window, so scroll events are caught in the capture phase. */
(function () {
  var header = document.querySelector('[data-ep-header]');
  if (!header) return;
  var on = false;
  function update(e) {
    var t = e && e.target && e.target.scrollTop !== undefined ? e.target : null;
    var y = Math.max(window.scrollY || 0, t ? t.scrollTop : 0);
    var next = y > 24;
    if (next !== on) { on = next; header.classList.toggle('is-stuck', on); }
  }
  document.addEventListener('scroll', update, { capture: true, passive: true });
  update();
})();
